import React from "react";
import { NavLink } from "react-router-dom";

function Footer()
{
    return (
        <div>
            <footer className="pt-5 my-5 text-muted border-top">
                &copy; 2025 &middot; Lucas RODRIGUEZ &middot; <NavLink to="/contact">Contact</NavLink>
            </footer>
        </div>
    );
}
export default Footer;